export default {
  sects: [
    "浄土宗",
    "浄土真宗",
    "真言宗",
    "曹洞宗",
    "天台宗",
    "日蓮宗",
    "臨済宗",
    "その他",
  ],
};
